import React, { createContext, useContext, useState, useEffect } from "react";

const LocaleContext = createContext(null);

const defaultTranslations = {
  en: {
    "footer.copyright": "Copyright © 2025 HsEmail. All Rights Reserved.",
    "lang.chinese": "中文",
    "lang.english": "English",
    // 侧边栏
    "sidebar.dashboard": "Dashboard",
    "sidebar.users": "Users",
    "sidebar.emails": "Emails",
    "sidebar.proxy": "Proxy",
    "sidebar.files": "Files",
    "sidebar.whitelist": "Whitelist",
    // 趋势图
    "trend.title": "Trend",
    "legend.success": "Success",
    "legend.fail": "Fail",
    "legend.total": "Total",
    "main.all_users": "All Users",
    "summary.success": "Success",
    "summary.fail": "Fail",
    // 白名单
    "whitelist.add": "Add whitelist",
    "whitelist.search_placeholder": "Search here",
    "whitelist.no_items": "No whitelist items",
    "whitelist.table.url": "URL/DNS/IP",
    "whitelist.table.description": "Description",
    "whitelist.table.date": "Date",
    "whitelist.table.operation": "Operation",
    "white.modal.add": "Add Whitelist",
    "white.modal.edit": "Edit Whitelist",
    "white.modal.url_label": "URL or Address",
    "white.modal.description_label": "Description",
    "white.modal.cancel": "Cancel",
    "white.modal.save": "Save",
    "white.modal.url_required": "URL or Address is required",
    "pagination.go_to": "Go to",
    "pagination.go": "Go",
    "pagination.per_page": "{n} / page",
    "confirm.delete_whitelist.title": "Delete Whitelist",
    "confirm.delete_whitelist.description":
      "Are you sure you want to delete this whitelist item?",
    "confirm.delete": "Delete",
    "confirm.cancel": "Cancel",
    "notification.whitelist_added": "Whitelist added",
    "notification.whitelist_updated": "Whitelist updated",
    "notification.whitelist_deleted": "Whitelist deleted",
    "notification.failed_save": "Failed to save whitelist",
    "notification.failed_delete": "Failed to delete whitelist",
    "status.on": "ON",
    "status.off": "OFF",
    // Users
    "users.add": "Add user",
    "users.search_placeholder": "Search here",
    "users.no_items": "No contacts",
    "users.role.user": "User",
    "users.role.admin": "Admin",
    "users.table.account": "Account",
    "users.table.password": "Password",
    "users.table.nickname": "NickName",
    "users.table.role": "Role",
    "users.table.operation": "Operation",
    "confirm.delete_user.title": "Delete User",
    "confirm.delete_user.description":
      'Are you sure you want to delete the user "{name}"?',
    "notification.user_deleted": "User deleted successfully!",
    "notification.failed_delete_user": "Failed to delete user",
    "user.modal.add": "Add a User",
    "user.modal.save": "Save",
    "user.modal.cancel": "Cancel",
    "user.modal.account_required": "Account is required",
    "user.modal.password_required": "Password is required",
    // Files
    "files.search_placeholder": "Search by name",
    "files.add": "Add file",
    "files.no_items": "No files",
    "files.table.filename": "Filename",
    "files.table.status": "Status",
    "files.table.file_key": "File Key",
    "files.table.key": "Key",
    "files.table.content": "Content",
    "files.table.date": "Date",
    "files.table.operation": "Operation",
    "file.modal.add": "Add file",
    "file.modal.edit": "Edit file",
    "file.modal.preview": "Preview",
    "file.modal.filename_label": "File's Name",
    "file.modal.title_label": "File's Title",
    "file.modal.status_label": "Status",
    "notification.file_added": "File added",
    "notification.file_updated": "File updated",
    "notification.file_deleted": "File deleted",
    "notification.file_delete_failed": "Failed to delete file",

    // Proxy
    "proxy.search_placeholder": "Search by host",
    "proxy.add_one": "Add one proxy",
    "proxy.add_one_desc": "Add a single proxy entry",
    "proxy.add": "Add proxies",
    "proxy.no_items": "No proxies",
    "proxy.table.host": "Host",
    "proxy.table.port": "Port",
    "proxy.table.account": "Account",
    "proxy.table.password": "Password",
    "proxy.table.type": "Type",
    "proxy.table.status": "Status",
    "proxy.table.date": "Date",
    "proxy.table.operation": "Operation",
    "proxy.modal.add": "Add proxy",
    "proxy.modal.edit": "Edit proxy",
    "notification.proxy_added": "Proxy added",
    "notification.proxy_deleted": "Proxy deleted",
    "proxy.bulk.title": "Batch add proxies",
    "proxy.bulk.format_hint": "(host,port,account,password,SOCKS5)",
    // Emails
    "emails.add": "Add emails",
    "emails.add_one": "Add one email",
    "emails.add_one_desc": "Add a single email",
    "emails.add_many": "Add emails",
    "emails.add_many_desc":
      "Add multiple emails at once by manually copying and pasting information",
    "emails.bulk.title": "Batch add emails",
    "emails.bulk.format_hint":
      "(account,password,key,port,smtp,address | host,port,account,password,SOCKS5)",
    "emails.bulk.instructions": "Enter one CSV per line",
    "emails.adding": "Adding...",
    "emails.search_placeholder": "Search here",
    "emails.no_items": "No emails",
    // Filters (used in Main.js)
    "filters.title": "Filters",
    "filter.start_time": "Start Time",
    "filter.end_time": "End Time",
    "filter.order_user": "Order User",
    "filter.all": "All",
    "emails.table.mail_user": "Mail User",
    "emails.table.ip": "IP",
    "emails.table.mail_key": "Mail Key",
    "emails.table.mail_password": "Mail Password",
    "emails.table.port": "Port",
    "emails.table.smtp_server": "SMTP Server",
    "emails.table.status": "Status",
    "emails.table.date": "Date",
    "emails.table.operation": "Operation",
    "email.modal.add": "Add Email",
    "email.modal.edit": "Edit Email",
    "email.modal.mail_user_required": "Mail User is required",
    "email.modal.mail_password_required": "Mail Password is required",
    "email.modal.smtp_required": "SMTP Server is required",
    "email.modal.port_required": "Port is required",
    "email.modal.port_number": "Port must be a number",
    "confirm.delete_proxy": "Delete Proxy",
    "confirm.delete_proxy.description":
      "Are you sure you want to delete this proxy?",
    "notification.email_added": "Email added",
    "notification.email_deleted": "Email deleted",
    "confirm.delete_email.title": "Delete Email",
    "confirm.delete_email.description":
      "Are you sure you want to delete this email account?",
    "confirm.delete_file.title": "Delete File",
    "confirm.delete_file.description":
      "Are you sure you want to delete this file?",
    // Send email modal
    "send.to_email": "To Email",
    "send.select_file": "Select File",
    "send.subject_key": "Subject Key :",
    "send.subject_replace": "Subject Replace",
    "send.replace_key": "Replace Key :",
    "send.replace_value": "Replace Value",
    "send.input_string": "Input String",
    "send.check": "Check",
    "send.preview": "Preview",
    "send.cancel": "Cancel",
    "send.send": "Send",
    // Login page
    "login.title": "Login",
    "login.username": "Username",
    "login.password": "Password",
    "login.code": "Code",
    "login.get_code": "Get Code",
    "login.login": "LOGIN",
    "login.loading": "Loading...",
    "login.enter_username": "Please enter your username",
    "login.enter_password": "Please enter your password",
    "login.enter_code": "Please enter code",
    "login.code_sent": "Verification code has been sent",
    "login.code_failed": "Failed to get verification code",
    "login.success": "Login successful",
    "login.failed": "Login failed. Please try again",
    "header.logout": "Logout",
  },
  zh: {
    "footer.copyright": "版权所有 © 2025 HsEmail。保留所有权利。",
    "lang.chinese": "中文",
    "lang.english": "English",
    "sidebar.dashboard": "仪表盘",
    "sidebar.users": "用户",
    "sidebar.emails": "邮件",
    "sidebar.proxy": "代理",
    "sidebar.files": "文件",
    "sidebar.whitelist": "白名单",
    "trend.title": "趋势",
    "legend.success": "成功",
    "legend.fail": "失败",
    "legend.total": "总计",
    "main.all_users": "所有用户",
    "summary.success": "成功",
    "summary.fail": "失败",
    "whitelist.add": "添加白名单",
    "whitelist.search_placeholder": "搜索",
    "whitelist.no_items": "暂无白名单",
    "whitelist.table.url": "站点",
    "whitelist.table.description": "描述",
    "whitelist.table.date": "日期",
    "whitelist.table.operation": "操作",
    "white.modal.add": "添加白名单",
    "white.modal.edit": "编辑白名单",
    "white.modal.url_label": "URL 或 地址",
    "white.modal.description_label": "描述",
    "white.modal.cancel": "取消",
    "white.modal.save": "保存",
    "white.modal.url_required": "必须填写 URL 或 地址",
    "pagination.go_to": "跳转到",
    "pagination.go": "确定",
    "pagination.per_page": "{n} / 页",
    "confirm.delete_whitelist.title": "删除白名单",
    "confirm.delete_whitelist.description": "确定要删除该白名单项吗？",
    "confirm.delete": "删除",
    "confirm.cancel": "取消",
    "notification.whitelist_added": "白名单已添加",
    "notification.whitelist_updated": "白名单已更新",
    "notification.whitelist_deleted": "白名单已删除",
    "notification.failed_save": "保存白名单失败",
    "notification.failed_delete": "删除白名单失败",
    "status.on": "开启",
    "status.off": "关闭",
    // Users
    "users.add": "添加用户",
    "users.search_placeholder": "搜索",
    "users.no_items": "暂无联系人",
    "users.role.user": "用户",
    "users.role.admin": "管理员",
    "users.table.account": "账户",
    "users.table.password": "密码",
    "users.table.nickname": "昵称",
    "users.table.role": "角色",
    "users.table.operation": "操作",
    "confirm.delete_user.title": "删除用户",
    "confirm.delete_user.description": "确定要删除用户“{name}”吗？",
    "notification.user_deleted": "用户已删除",
    "notification.failed_delete_user": "删除用户失败",
    "user.modal.add": "添加用户",
    "user.modal.save": "保存",
    "user.modal.cancel": "取消",
    "user.modal.account_required": "必须填写账户",
    "user.modal.password_required": "必须填写密码",
    // Files
    "files.search_placeholder": "按名称搜索",
    "files.add": "添加文件",
    "files.no_items": "暂无文件",
    "files.table.filename": "文件名",
    "files.table.status": "状态",
    "files.table.date": "日期",
    "files.table.operation": "操作",
    "file.modal.add": "添加文件",
    "file.modal.edit": "编辑文件",
    "file.modal.preview": "预览",
    "file.modal.filename_label": "文件名",
    "file.modal.title_label": "文件标题",
    "file.modal.status_label": "状态",
    "notification.file_added": "文件已添加",
    "notification.file_updated": "文件已更新",
    "notification.file_deleted": "文件已删除",
    "files.table.file_key": "文件密钥",
    "files.table.key": "密钥",
    "files.table.content": "文本",
    // Proxy
    "proxy.search_placeholder": "按 Host 搜索",
    "proxy.add_one": "添加代理",
    "proxy.add_one_desc": "添加单个代理",
    "proxy.add": "添加代理",
    "proxy.add_many_desc": "一次添加多个代理，按行粘贴 CSV",
    "proxy.no_items": "暂无代理",
    "proxy.table.host": "主机/服务器",
    "proxy.table.port": "端口",
    "proxy.table.account": "账号",
    "proxy.table.password": "密码",
    "proxy.table.type": "类型",
    "proxy.table.status": "状态",
    "proxy.table.date": "日期",
    "proxy.table.operation": "操作",
    "proxy.modal.add": "添加代理",
    "proxy.modal.edit": "编辑代理",
    "notification.proxy_added": "代理已添加",
    "notification.proxy_deleted": "代理已删除",
    "notification.proxy_delete_failed": "删除代理失败",
    "confirm.delete_proxy": "删除代理",
    "confirm.delete_proxy.description": "确定要删除该代理吗？",
    "proxy.bulk.title": "批量添加代理",
    "proxy.bulk.format_hint": "(主机,端口,账号,密码,SOCKS5)",
    // Emails
    "emails.add": "添加邮件",
    "emails.add_one": "添加邮件",
    "emails.add_one_desc": "添加单个邮件",
    "emails.add_many": "添加多个邮件",
    "emails.add_many_desc": "一次添加多个邮件，按行粘贴 CSV",
    "emails.bulk.title": "批量添加邮件",
    "emails.bulk.format_hint":
      "(账号,密码,密钥,端口,SMTP,地址 | 主机,端口,账号,密码,SOCKS5)",
    "emails.bulk.instructions": "每行输入一条 CSV",
    "emails.adding": "添加中...",
    "emails.search_placeholder": "搜索",
    // Filters (used in Main.js)
    filters: "筛选",
    "filter.start_time": "开始时间",
    "filter.end_time": "结束时间",
    "filter.order_user": "订单用户",
    "filter.all": "全部",
    "emails.no_items": "暂无邮件",
    "emails.table.mail_user": "邮件账户",
    "emails.table.ip": "IP地址",
    "emails.table.mail_key": "邮箱密钥",
    "emails.table.mail_password": "邮件密码",
    "emails.table.port": "端口",
    "emails.table.smtp_server": "SMTP 服务器",
    "emails.table.status": "状态",
    "emails.table.date": "日期",
    "emails.table.operation": "操作",
    "email.modal.add": "添加邮件",
    "email.modal.edit": "编辑邮件",
    "notification.email_added": "邮件已添加",
    "notification.email_deleted": "邮件已删除",
    "notification.failed_delete_email": "删除邮件失败",
    "confirm.delete_email.title": "删除邮件",
    "confirm.delete_email.description": "确定要删除该邮箱账户吗？",
    "confirm.delete_file.title": "删除文件",
    "confirm.delete_file.description": "确定要删除该文件吗？",
    // Send email modal
    "send.to_email": "邮件接收者",
    "send.select_file": "选择文件模版",
    "send.subject_key": "主题关键词:",
    "send.subject_replace": "主题替换",
    "send.replace_key": "替换关键词:",
    "send.replace_value": "替换值",
    "send.input_string": "检测字符串",
    "send.check": "检测",
    "send.preview": "预览",
    "send.cancel": "取消",
    "send.send": "发送",
    // Login page
    "login.title": "登录",
    "login.username": "用户名",
    "login.password": "密码",
    "login.code": "验证码",
    "login.get_code": "获取验证码",
    "login.login": "登录",
    "login.loading": "加载中...",
    "login.enter_username": "请输入用户名",
    "login.enter_password": "请输入密码",
    "login.enter_code": "请输入验证码",
    "login.code_sent": "验证码已发送",
    "login.code_failed": "获取验证码失败",
    "login.success": "登录成功",
    "login.failed": "登录失败，请重试",
    "header.logout": "退出登录",
    "email.modal.mail_user_required": "必须填写邮箱账户",
    "email.modal.mail_password_required": "必须填写邮箱密码",
    "email.modal.smtp_required": "必须填写 SMTP Server",
    "email.modal.port_required": "必须填写端口",
    "email.modal.port_number": "端口必须为数字",
  },
};

export const LocaleProvider = ({
  children,
  defaultLocale = "zh",
  translations,
}) => {
  const detectBrowserLocale = () => {
    try {
      if (typeof navigator === "undefined") return null;
      const navLang =
        (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        navigator.userLanguage ||
        null;
      if (!navLang) return null;
      // map zh* -> zh, everything else -> en
      return navLang.toLowerCase().startsWith("zh") ? "zh" : "en";
    } catch (e) {
      return null;
    }
  };

  const initialLocale =
    typeof window !== "undefined"
      ? localStorage.getItem("locale") || detectBrowserLocale() || defaultLocale
      : defaultLocale;
  const [locale, setLocaleState] = useState(initialLocale);
  const merged = { ...defaultTranslations, ...(translations || {}) };

  // persist and apply HTML lang attribute so native date pickers use correct locale
  useEffect(() => {
    try {
      localStorage.setItem("locale", locale);
    } catch (e) {
      // ignore
    }
    const htmlLang = locale === "zh" ? "zh-CN" : "en-US";
    if (typeof document !== "undefined") {
      document.documentElement.setAttribute("lang", htmlLang);
    }
  }, [locale]);

  const setLocale = (next) => {
    setLocaleState(next);
  };

  const t = (key, vars) => {
    const dict = merged[locale] || {};
    let v = dict[key] ?? key;
    if (vars && typeof v === "string") {
      Object.keys(vars).forEach((k) => {
        v = v.replace(`{${k}}`, String(vars[k]));
      });
    }
    return v;
  };

  return (
    <LocaleContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useTranslation = () => {
  const ctx = useContext(LocaleContext);
  if (!ctx) {
    return {
      t: (k) => k,
      locale: "zh",
      setLocale: () => {},
    };
  }
  return { t: ctx.t, locale: ctx.locale, setLocale: ctx.setLocale };
};

export default LocaleContext;
